import { gql } from "@apollo/client";

export const TRACK = gql`
	mutation track($type: String!, $properties: String, $context: AnalyticsContextInput) {
		track(type: $type, properties: $properties, context: $context)
	}
`;

export const PAGE = gql`
	mutation page($name: String, $properties: String, $context: AnalyticsContextInput) {
		page(name: $name, properties: $properties, context: $context)
	}
`;
